import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-200 pt-12 pb-8" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-28">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-1" data-id="element-29">
            <img src="https://cdn.magicpatterns.com/uploads/1hCDA3zzdjWRL7TqBKyeWc/Best-Vitamins-For-All.webp" alt="Best Vitamins For All" className="h-10 w-auto mb-4" data-id="element-30" />
            <p className="text-sm text-gray-500 mb-4" data-id="element-31">
              Providing the finest, safest, and most effective nutritional
              products since 1958.
            </p>
            <div className="flex items-center text-gray-600 mb-2" data-id="element-32">
              <Phone className="h-4 w-4 mr-2 text-[#0e7be1]" data-id="element-33" />
              <span className="text-sm" data-id="element-34">800-260-2808</span>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-35">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4" data-id="element-36">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-37">
              <li data-id="element-38">
                <a href="#" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-39">
                  Home
                </a>
              </li>
              <li data-id="element-40">
                <a href="#" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-41">
                  Products
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-43">
                  Join NeoLife
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-45">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div data-id="element-46">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4" data-id="element-47">
              Support
            </h3>
            <ul className="space-y-3" data-id="element-48">
              <li data-id="element-49">
                <a href="#" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-50">
                  About Us
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-52">
                  Resources
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-54">
                  Distributor Login
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-56">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Logo Column */}
          <div className="flex flex-col items-center md:items-end justify-start" data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/ssrgMdZGi9uTcmdb8AVR45/GNLD-secondary-logo.webp" alt="GNLD NeoLife" className="h-20 w-auto opacity-90" data-id="element-58" />
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-59">
          <p className="text-sm text-gray-500 text-center md:text-left" data-id="element-60">
            &copy; 2024 BestVitaminsForAll.com - GNLD NeoLife Independent
            Distributor
          </p>
          <p className="text-xs text-gray-400 mt-2 md:mt-0 text-center md:text-right max-w-md" data-id="element-61">
            These statements have not been evaluated by the Food and Drug
            Administration. These products are not intended to diagnose, treat,
            cure or prevent any disease.
          </p>
        </div>
      </div>
    </footer>;
}